import { render, staticRenderFns } from "./RelativeRelationTypeInfo.vue?vue&type=template&id=30628f64&"
import script from "./RelativeRelationTypeInfo.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports